import * as React from 'react';
import { formatDollars } from '../OverTimeSection/ChargesOverTime/utility';
import { Symbol } from './Symbol';

export interface Field {
  field: string;
  variant: 'disputable' | 'non-disputable';
  isPast: boolean;
  value?: number;
}

interface Props {
  fields: Field[];
}

export const GraphTooltip: React.FC<Props> = (props) => {
  const { fields } = props;

  const symbols = fields.map((f) => {
    return (
      <Symbol variant={f.variant} isPast={f.isPast} key={f.field}>
        {f.value === undefined ? 'No data' : formatDollars(f.value)}
      </Symbol>
    );
  });
  return <div className="bg-gray-600 p-1 rounded space-y-1">{symbols}</div>;
};
GraphTooltip.displayName = 'GraphTooltip';
